import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';

const Text = ( props ) => {
    const {
        details: {
            name,
            className,
            text
        },
        index,
        replacements
    } = props;

    return (
        <Fragment>
            <li className={className} id={`${name}_${index}`} data-automation-id={name}>
                <FormattedMessage
                    id = {text}
                    values = {replacements}
                />
            </li>
        </Fragment>
    );
};

export default Text;